module.exports = __webpack_public_path__ + "img/solucion bucofaringea.9872d70a.png";